import {
  jb_timer_css_default
} from "./chunk.HYDWYODY.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n,
  r as r2
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-timer/jb-timer.ts
var JbTimer = class extends r {
  constructor() {
    super(...arguments);
    this.align = "left";
  }
  update(changedProperties) {
    super.update(changedProperties);
    if (changedProperties.has("seconds")) {
      this._displayMinutes = Math.floor(Math.abs(this.seconds) / 60).toString().padStart(2, "0");
      this._displaySeconds = Math.round(Math.abs(this.seconds) % 60).toString().padStart(2, "0");
    }
  }
  render() {
    return ke`<div class=${Rt({ "right-aligned": this.align === "right" })}>
      ${this.seconds < 0 ? "-" : ""}${this._displayMinutes}:${this._displaySeconds}
    </div>`;
  }
};
JbTimer.styles = jb_timer_css_default;
__decorateClass([
  n()
], JbTimer.prototype, "align", 2);
__decorateClass([
  n({ type: Number })
], JbTimer.prototype, "seconds", 2);
__decorateClass([
  r2()
], JbTimer.prototype, "_displayMinutes", 2);
__decorateClass([
  r2()
], JbTimer.prototype, "_displaySeconds", 2);
JbTimer = __decorateClass([
  customElement("jb-timer")
], JbTimer);

export {
  JbTimer
};
